module.exports = __webpack_public_path__ + "img/ic_drop_up.58d4703c.svg";